/**
 * Converts a given string to title case.
 * 
 * This function replaces hyphens with spaces and capitalizes the first letter of each word,
 * making the rest of the letters in each word lowercase.
 *
 * @param str - The input string to be converted to title case.
 * @returns The title-cased version of the input string.
 */
export default function textTitleCase(str: string): string {
  return String(str)
    .replace(/-/g, " ")
    .replace(/\w\S*/g, (txt: string) => txt.charAt(0).toUpperCase() + txt.slice(1).toLowerCase());
}
